// import React from "react";
// import { SlLocationPin } from "react-icons/sl";
// import { MdOutlineEmail } from "react-icons/md";
// import { IoCallOutline } from "react-icons/io5";
// import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";

// const Enquiery = () => {
//     const leftPanelBg = "#f5f8fd";     // left side bg (as requested)
//     const inputBg = "#f5f8fd";         // inputs bg (as requested)
//     const primaryBlue = "#0b4a8f";     // icon + heading + button

//     const inputStyle = {
//         backgroundColor: inputBg,
//         border: "1px solid #e6ecf5",
//         boxShadow: "none",
//         fontSize: "16px",
//     };

//     const headingStyle = {
//         color: primaryBlue,
//         fontSize: "32px",
//         fontFamily: "'Inter', sans-serif",
//         fontWeight: 650,
//         lineHeight: 1,
//     };

//     const iconWrap = {
//         width: 38,
//         height: 38,
//         background: "#e8f0fb",
//         color: primaryBlue,
//     };

//     const socialWrap = {
//         marginTop: 4,
//         width: 34,
//         height: 34,
//         background: "#e8f0fb",
//         color: primaryBlue,
//     };

//     const onSubmit = (e) => {
//         e.preventDefault();
//         // handle submit
//     };

//     return (
//         <section className="py-5 position-relative"
//             style={{
//                 overflow: "hidden",
//                 marginTop: 50,

//             }}
//         >
//             <div className="px-3 px-md-4 mx-auto position-relative"
//                 style={{
//                     maxWidth: "73%",
//                     zIndex: 1
//                 }}
//             >
//                 <div className="rounded-4 shadow-sm overflow-hidden">
//                     <div className="row g-0">
//                         {/* LEFT PANEL */}
//                         <div className="col-12 col-lg-5 p-4 p-md-5" style={{ background: leftPanelBg }}>
//                             <div className="d-flex align-items-center gap-2 mb-3">
//                                 <h4 className="m-0" style={headingStyle}>Get in touch</h4>
//                             </div>

//                             <p className="text-muted mb-4"
//                                 style={{
//                                     fontSize: '18px',
//                                     lineHeight: '1.2',
//                                     fontFamily: "'Inter', sans-serif",
//                                 }}
//                             >
//                                 We are here to help. Reach out with your queries, ideas, or
//                                 support needs- our team will respond promptly.
//                             </p>

//                             {/* Address */}
//                             <div className="d-flex align-items-start gap-3 mb-3">
//                                 <div className="d-inline-flex align-items-center justify-content-center rounded-circle" style={iconWrap}>
//                                     <SlLocationPin size={20} />
//                                 </div>
//                                 <div>
//                                     <div className="fw-semibold"
//                                         style={{
//                                             fontSize: '20px',
//                                             color: '#1C1C1C',
//                                             fontFamily: "'Inter', sans-serif",
//                                         }}
//                                     >
//                                         Corporate office address:
//                                     </div>
//                                     <div className="small text-muted"
//                                         style={{
//                                             marginTop: 2,
//                                             fontSize: '16px',
//                                             color: '#1C1C1C',
//                                             fontFamily: "'Inter', sans-serif",
//                                             lineHeight: '1.2'
//                                         }}
//                                     >
//                                         H.O. Block-86, Plot-2, Nehru Nagar East, Bhilai,
//                                         Chhattisgarh 490020
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Email */}
//                             <div className="d-flex align-items-start gap-3 mb-3">
//                                 <div className="d-inline-flex align-items-center justify-content-center rounded-circle" style={iconWrap}>
//                                     <MdOutlineEmail size={20} />
//                                 </div>
//                                 <div>
//                                     <div className="fw-semibold"
//                                         style={{
//                                             fontSize: '20px',
//                                             color: '#1C1C1C',
//                                             fontFamily: "'Inter', sans-serif",
//                                         }}
//                                     >

//                                         Email Us
//                                     </div>
//                                     <div className="small">
//                                         <a href="mailto:info@atmikbharat.com" className="text-decoration-none"
//                                             style={{
//                                                 marginTop: 2,
//                                                 fontSize: '16px',
//                                                 fontFamily: "'Inter', sans-serif",
//                                                 lineHeight: '1.2'
//                                             }}
//                                         >
//                                             info@atmikbharat.com
//                                         </a>
//                                         <br />
//                                         <a href="mailto:hello@yourdomain.id" className="text-decoration-none"
//                                             style={{
//                                                 marginTop: 2,
//                                                 fontSize: '16px',
//                                                 fontFamily: "'Inter', sans-serif",
//                                                 lineHeight: '1.2'
//                                             }}

//                                         >
//                                             hello@yourdomain.id
//                                         </a>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Call */}
//                             <div className="d-flex align-items-start gap-3 mb-4">
//                                 <div className="d-inline-flex align-items-center justify-content-center rounded-circle" style={iconWrap}>
//                                     <IoCallOutline size={20} />
//                                 </div>
//                                 <div>
//                                     <div className="fw-semibold"
//                                         style={{
//                                             fontSize: '20px',
//                                             color: '#1C1C1C',
//                                             fontFamily: "'Inter', sans-serif",
//                                         }}
//                                     >
//                                         Call Us
//                                     </div>
//                                     <div className="small text-muted"
//                                         style={{
//                                             marginTop: 2,
//                                             fontSize: '16px',
//                                             fontFamily: "'Inter', sans-serif",
//                                             lineHeight: '1.2'
//                                         }}

//                                     >
//                                         Phone: +91-7349064541
//                                         <br />
//                                         Fax: +6221.2002.2013
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Social */}
//                             <div>
//                                 <div className="fw-semibold mb-2"
//                                     style={{
//                                         fontSize: '20px',
//                                         color: '#1C1C1C',
//                                         fontFamily: "'Inter', sans-serif",
//                                     }}

//                                 > Follow our social media
//                                 </div>
//                                 <div className="d-flex align-items-center gap-3">
//                                     <a href="#!" className="d-inline-flex align-items-center justify-content-center rounded-circle" style={socialWrap} aria-label="Facebook">
//                                         <FaFacebookF size={14} />
//                                     </a>
//                                     <a href="#!" className="d-inline-flex align-items-center justify-content-center rounded-circle" style={socialWrap} aria-label="Twitter">
//                                         <FaTwitter size={14} />
//                                     </a>
//                                     <a href="#!" className="d-inline-flex align-items-center justify-content-center rounded-circle" style={socialWrap} aria-label="LinkedIn">
//                                         <FaLinkedinIn size={14} />
//                                     </a>
//                                     <a href="#!" className="d-inline-flex align-items-center justify-content-center rounded-circle" style={socialWrap} aria-label="Instagram">
//                                         <FaInstagram size={15} />
//                                     </a>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* RIGHT PANEL – FORM */}
//                         <div className="col-12 col-lg-7 p-4 p-md-5 bg-white">
//                             <div className="d-flex align-items-center gap-2 mb-3">
//                                 <h4 className="m-0" style={headingStyle}>Send us a message</h4>
//                             </div>

//                             <form onSubmit={onSubmit}>
//                                 {/* Row 1 */}
//                                 <div className="row g-3">
//                                     <div className="col-md-6">
//                                         <label className="form-label small text-muted"
//                                             style={{
//                                                 fontSize: "18px",
//                                                 fontWeight: 580,
//                                                 color: "#6c757d"
//                                             }}
//                                         >
//                                             Name
//                                         </label>
//                                         <input
//                                             type="text"
//                                             className="form-control form-control-lg rounded-3"
//                                             style={inputStyle}
//                                             placeholder="Enter your name"
//                                             required
//                                         />
//                                     </div>
//                                     <div className="col-md-6">
//                                         <label className="form-label small text-muted"
//                                             style={{
//                                                 fontSize: "18px",
//                                                 fontWeight: 580,
//                                                 color: "#6c757d"
//                                             }}
//                                         >
//                                             Company
//                                         </label>
//                                         <input
//                                             type="text"
//                                             className="form-control form-control-lg rounded-3"
//                                             style={inputStyle}
//                                             placeholder="Enter company name"
//                                         />
//                                     </div>
//                                 </div>

//                                 {/* Row 2 */}
//                                 <div className="row g-3 mt-1">
//                                     <div className="col-md-6">
//                                         <label className="form-label small text-muted"
//                                             style={{
//                                                 fontSize: "18px",
//                                                 fontWeight: 580,
//                                                 color: "#6c757d"
//                                             }}
//                                         >
//                                             Phone
//                                         </label>
//                                         <input
//                                             type="tel"
//                                             className="form-control form-control-lg rounded-3"
//                                             style={inputStyle}
//                                             placeholder="Enter your phone number"
//                                         />
//                                     </div>
//                                     <div className="col-md-6">
//                                         <label className="form-label small text-muted" style={{
//                                             fontSize: "18px",
//                                             fontWeight: 580,
//                                             color: "#6c757d"
//                                         }}
//                                         >
//                                             Email
//                                         </label>
//                                         <input
//                                             type="email"
//                                             className="form-control form-control-lg rounded-3"
//                                             style={inputStyle}
//                                             placeholder="Enter your email"
//                                             required
//                                         />
//                                     </div>
//                                 </div>

//                                 {/* Message */}
//                                 <div className="mt-3">
//                                     <label className="form-label small text-muted"
//                                         style={{
//                                             fontSize: "18px",
//                                             fontWeight: 580,
//                                             color: "#6c757d"
//                                         }}
//                                     >
//                                         Message
//                                     </label>
//                                     <textarea
//                                         rows={5}
//                                         className="form-control form-control-lg rounded-3"
//                                         style={inputStyle}
//                                         placeholder="Write your message here"
//                                     />
//                                 </div>

//                                 {/* Button */}
//                                 <div className="mt-4">
//                                     <button
//                                         type="submit"
//                                         className="btn btn-lg w-100 rounded-3 text-white"
//                                         style={{ background: primaryBlue }}
//                                     >
//                                         SEND
//                                     </button>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default Enquiery;



import React from "react";
import { SlLocationPin } from "react-icons/sl";
import { MdOutlineEmail } from "react-icons/md";
import { IoCallOutline } from "react-icons/io5";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";

const Enquiery = () => {
    const leftPanelBg = "#f5f8fd";     // left side bg
    const inputBg = "#f5f8fd";         // inputs bg
    const primaryBlue = "#0b4a8f";     // icon + heading + button

    const inputStyle = {
        backgroundColor: inputBg,
        border: "1px solid #e6ecf5",
        boxShadow: "none",
        fontSize: "16px",
    };

    const headingStyle = {
        color: primaryBlue,
        fontSize: "32px",
        fontFamily: "'Inter', sans-serif",
        fontWeight: 650,
        lineHeight: 1,
    };

    const iconWrap = {
        width: 38,
        height: 38,
        background: "#e8f0fb",
        color: primaryBlue,
    };

    const socialWrap = {
        marginTop: 4,
        width: 34,
        height: 34,
        background: "#e8f0fb",
        color: primaryBlue,
    };

    const onSubmit = (e) => {
        e.preventDefault();
        // handle submit
    };

    return (
        <>
            {/* Inline CSS (no separate file needed) */}
            <style>{`
        @keyframes fadeInTop {
          0% { opacity: 0; transform: translateY(-30px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes floatPulse {
          0% { transform: translateY(0px) scale(1); }
          100% { transform: translateY(-20px) scale(1.05); }
        }
      `}</style>

            <section
                className="py-5 position-relative"
                style={{
                    overflow: "hidden",
                    marginTop: 50,
                    background: "linear-gradient(135deg, #E6F1FB 0%, #F4F9FF 100%)",
                    animation: "fadeInTop 1.2s ease forwards",
                }}
            >
                {/* floating glow bubbles */}
                <div
                    aria-hidden
                    className="bubble bubble-tl"
                    style={{
                        position: "absolute",
                        top: "-140px",
                        left: "-140px",
                        width: "420px",
                        height: "420px",
                        borderRadius: "50%",
                        background:
                            "radial-gradient(closest-side, rgba(142,179,213,0.4), rgba(142,179,213,0) 80%)",
                        filter: "blur(2px)",
                        animation: "floatPulse 10s ease-in-out infinite alternate",
                        pointerEvents: "none",
                        zIndex: 0,
                    }}
                />
                <div
                    aria-hidden
                    className="bubble bubble-br"
                    style={{
                        position: "absolute",
                        bottom: "-160px",
                        right: "-160px",
                        width: "520px",
                        height: "520px",
                        borderRadius: "50%",
                        background:
                            "radial-gradient(closest-side, rgba(170,195,221,0.4), rgba(170,195,221,0) 80%)",
                        filter: "blur(2px)",
                        animation: "floatPulse 12s ease-in-out 1s infinite alternate",
                        pointerEvents: "none",
                        zIndex: 0,
                    }}
                />

                <div
                    className="px-3 px-md-4 mx-auto position-relative"
                    style={{ maxWidth: "73%", zIndex: 1 }}
                >
                    <div className="rounded-4 shadow-sm overflow-hidden">
                        <div className="row g-0">
                            {/* LEFT PANEL */}
                            <div
                                className="col-12 col-lg-5 p-4 p-md-5"
                                style={{ background: leftPanelBg }}
                            >
                                <div className="d-flex align-items-center gap-2 mb-3">
                                    <h4 className="m-0" style={headingStyle}>
                                        Get in touch
                                    </h4>
                                </div>

                                <p
                                    className="text-muted mb-4"
                                    style={{
                                        fontSize: "18px",
                                        lineHeight: "1.2",
                                        fontFamily: "'Inter', sans-serif",
                                    }}
                                >
                                    We are here to help. Reach out with your queries, ideas, or
                                    support needs- our team will respond promptly.
                                </p>

                                {/* Address */}
                                <div className="d-flex align-items-start gap-3 mb-3">
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center rounded-circle"
                                        style={iconWrap}
                                    >
                                        <SlLocationPin size={20} />
                                    </div>
                                    <div>
                                        <div
                                            className="fw-semibold"
                                            style={{
                                                fontSize: "20px",
                                                color: "#1C1C1C",
                                                fontFamily: "'Inter', sans-serif",
                                            }}
                                        >
                                            Corporate office address:
                                        </div>
                                        <div
                                            className="small text-muted"
                                            style={{
                                                marginTop: 2,
                                                fontSize: "16px",
                                                color: "#1C1C1C",
                                                fontFamily: "'Inter', sans-serif",
                                                lineHeight: "1.2",
                                            }}
                                        >
                                            H.O. Block-86, Plot-2, Nehru Nagar East, Bhilai,
                                            Chhattisgarh 490020
                                        </div>
                                    </div>
                                </div>

                                {/* Email */}
                                <div className="d-flex align-items-start gap-3 mb-3">
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center rounded-circle"
                                        style={iconWrap}
                                    >
                                        <MdOutlineEmail size={20} />
                                    </div>
                                    <div>
                                        <div
                                            className="fw-semibold"
                                            style={{
                                                fontSize: "20px",
                                                color: "#1C1C1C",
                                                fontFamily: "'Inter', sans-serif",
                                            }}
                                        >
                                            Email Us
                                        </div>
                                        <div className="small">
                                            <a
                                                href="mailto:info@atmikbharat.com"
                                                className="text-decoration-none"
                                                style={{
                                                    marginTop: 2,
                                                    fontSize: "16px",
                                                    fontFamily: "'Inter', sans-serif",
                                                    lineHeight: "1.2",
                                                }}
                                            >
                                                info@atmikbharat.com
                                            </a>
                                            <br />
                                            <a
                                                href="mailto:hello@yourdomain.id"
                                                className="text-decoration-none"
                                                style={{
                                                    marginTop: 2,
                                                    fontSize: "16px",
                                                    fontFamily: "'Inter', sans-serif",
                                                    lineHeight: "1.2",
                                                }}
                                            >
                                                hello@yourdomain.id
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                {/* Call */}
                                <div className="d-flex align-items-start gap-3 mb-4">
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center rounded-circle"
                                        style={iconWrap}
                                    >
                                        <IoCallOutline size={20} />
                                    </div>
                                    <div>
                                        <div
                                            className="fw-semibold"
                                            style={{
                                                fontSize: "20px",
                                                color: "#1C1C1C",
                                                fontFamily: "'Inter', sans-serif",
                                            }}
                                        >
                                            Call Us
                                        </div>
                                        <div
                                            className="small text-muted"
                                            style={{
                                                marginTop: 2,
                                                fontSize: "16px",
                                                fontFamily: "'Inter', sans-serif",
                                                lineHeight: "1.2",
                                            }}
                                        >
                                            Phone: +91-7349064541
                                            <br />
                                            Fax: +6221.2002.2013
                                        </div>
                                    </div>
                                </div>

                                {/* Social */}
                                <div>
                                    <div
                                        className="fw-semibold mb-2"
                                        style={{
                                            fontSize: "20px",
                                            color: "#1C1C1C",
                                            fontFamily: "'Inter', sans-serif",
                                        }}
                                    >
                                        Follow our social media
                                    </div>
                                    <div className="d-flex align-items-center gap-3">
                                        <a
                                            href="#!"
                                            className="d-inline-flex align-items-center justify-content-center rounded-circle"
                                            style={socialWrap}
                                            aria-label="Facebook"
                                        >
                                            <FaFacebookF size={14} />
                                        </a>
                                        <a
                                            href="#!"
                                            className="d-inline-flex align-items-center justify-content-center rounded-circle"
                                            style={socialWrap}
                                            aria-label="Twitter"
                                        >
                                            <FaTwitter size={14} />
                                        </a>
                                        <a
                                            href="#!"
                                            className="d-inline-flex align-items-center justify-content-center rounded-circle"
                                            style={socialWrap}
                                            aria-label="LinkedIn"
                                        >
                                            <FaLinkedinIn size={14} />
                                        </a>
                                        <a
                                            href="#!"
                                            className="d-inline-flex align-items-center justify-content-center rounded-circle"
                                            style={socialWrap}
                                            aria-label="Instagram"
                                        >
                                            <FaInstagram size={15} />
                                        </a>
                                    </div>
                                </div>
                            </div>

                            {/* RIGHT PANEL – FORM */}
                            <div className="col-12 col-lg-7 p-4 p-md-5 bg-white">
                                <div className="d-flex align-items-center gap-2 mb-3">
                                    <h4 className="m-0" style={headingStyle}>
                                        Send us a message
                                    </h4>
                                </div>

                                <form onSubmit={onSubmit}>
                                    {/* Row 1 */}
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label
                                                className="form-label small text-muted"
                                                style={{
                                                    fontSize: "18px",
                                                    fontWeight: 580,
                                                    color: "#6c757d",
                                                }}
                                            >
                                                Name
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-lg rounded-3"
                                                style={inputStyle}
                                                placeholder="Enter your name"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label
                                                className="form-label small text-muted"
                                                style={{
                                                    fontSize: "18px",
                                                    fontWeight: 580,
                                                    color: "#6c757d",
                                                }}
                                            >
                                                Company
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-lg rounded-3"
                                                style={inputStyle}
                                                placeholder="Enter company name"
                                            />
                                        </div>
                                    </div>

                                    {/* Row 2 */}
                                    <div className="row g-3 mt-1">
                                        <div className="col-md-6">
                                            <label
                                                className="form-label small text-muted"
                                                style={{
                                                    fontSize: "18px",
                                                    fontWeight: 580,
                                                    color: "#6c757d",
                                                }}
                                            >
                                                Phone
                                            </label>
                                            <input
                                                type="tel"
                                                className="form-control form-control-lg rounded-3"
                                                style={inputStyle}
                                                placeholder="Enter your phone number"
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label
                                                className="form-label small text-muted"
                                                style={{
                                                    fontSize: "18px",
                                                    fontWeight: 580,
                                                    color: "#6c757d",
                                                }}
                                            >
                                                Email
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control form-control-lg rounded-3"
                                                style={inputStyle}
                                                placeholder="Enter your email"
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* Message */}
                                    <div className="mt-3">
                                        <label
                                            className="form-label small text-muted"
                                            style={{
                                                fontSize: "18px",
                                                fontWeight: 580,
                                                color: "#6c757d",
                                            }}
                                        >
                                            Message
                                        </label>
                                        <textarea
                                            rows={5}
                                            className="form-control form-control-lg rounded-3"
                                            style={inputStyle}
                                            placeholder="Write your message here"
                                        />
                                    </div>

                                    {/* Button */}
                                    <div className="mt-4">
                                        <button
                                            type="submit"
                                            className="btn btn-lg w-100 rounded-3 text-white"
                                            style={{
                                                background: primaryBlue,
                                                fontSize: '16px',
                                                fontFamily: "'Inter', sans-serif",
                                                fontWeight: 580,

                                            }}

                                        >
                                            SEND
                                        </button>
                                    </div>
                                </form>
                            </div>
                            {/* END RIGHT PANEL */}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Enquiery;
